import React from 'react';

import { BoxContainer } from '../../components';
import AddSemitrailerForm from './components/AddSemitrailerForm';

const PageContent = () => {
  return (
    <BoxContainer $useMarginBottom $useMarginTop>
      <AddSemitrailerForm />
    </BoxContainer>
  );
};

export default PageContent;
